import "bootstrap-icons/font/bootstrap-icons.css";

function SelectedPill({ opportunity, onRemove, compact = false }) {
    const label = opportunity?.title || opportunity?.opportunity || "Untitled";

    return (
        <span
            className={`inline-flex max-w-[7.5rem] shrink-0 items-center gap-1 rounded-full bg-violet-50 text-violet-900 ring-1 ring-violet-200/80 md:max-w-[11rem] ${
                compact ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
            }`}
        >
            <span className="min-w-0 truncate font-medium">{label}</span>
            <button
                type="button"
                onClick={() => onRemove(opportunity.id)}
                className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-violet-600 transition hover:bg-violet-100 hover:text-violet-900"
                aria-label={`Remove ${label}`}
            >
                <i className="bi bi-x text-sm leading-none" aria-hidden />
            </button>
        </span>
    );
}

function StackedFooterContent({ selected, onRemove, onStartCampaign }) {
    return (
        <div className="flex flex-col gap-2.5">
            <div className="flex max-h-7 flex-nowrap items-center gap-1.5 overflow-x-auto">
                {selected.map((item, index) => (
                    <SelectedPill
                        key={item.id ?? index}
                        opportunity={item}
                        onRemove={onRemove}
                        compact
                    />
                ))}
            </div>
            <button
                type="button"
                onClick={onStartCampaign}
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
                <i className="bi bi-arrow-right" aria-hidden />
                Continue to generate posts
            </button>
        </div>
    );
}

export default function OpportunitySelectionFooter({
    selected,
    onRemove,
    onStartCampaign,
    visible = true,
    mobileAndTabletOnly = false,
}) {
    if (!selected.length) return null;

    return (
        <div
            className={`fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200 bg-white/95 shadow-[0_-4px_24px_rgba(15,23,42,0.08)] backdrop-blur-sm transition-transform duration-300 ease-out md:left-[248px] ${
                visible ? "translate-y-0" : "translate-y-full pointer-events-none"
            } ${mobileAndTabletOnly ? "lg:hidden" : ""}`}
            role="region"
            aria-label="Selected trends"
            aria-hidden={!visible}
        >
            <div className="mx-auto max-w-5xl px-3 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] md:px-6 md:py-4">
                {mobileAndTabletOnly ? (
                    <StackedFooterContent
                        selected={selected}
                        onRemove={onRemove}
                        onStartCampaign={onStartCampaign}
                    />
                ) : (
                    <>
                        <div className="flex flex-col gap-2.5 md:hidden">
                            <StackedFooterContent
                                selected={selected}
                                onRemove={onRemove}
                                onStartCampaign={onStartCampaign}
                            />
                        </div>

                        <div className="hidden items-center justify-between gap-4 md:flex">
                            <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
                                {selected.map((item, index) => (
                                    <SelectedPill
                                        key={item.id ?? index}
                                        opportunity={item}
                                        onRemove={onRemove}
                                    />
                                ))}
                            </div>
                            <button
                                type="button"
                                onClick={onStartCampaign}
                                className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
                            >
                                <i className="bi bi-arrow-right" aria-hidden />
                                Continue to generate posts
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
